import { ReactNode, useCallback, useLayoutEffect, useMemo, useRef } from 'react'
import { PADDING_GAP } from '../../config'
import { useAppPageState } from '../useAppPageState'
import { getPageHeights } from '../../component-library/utils/getPageHeights'
import { useGetAppPage } from '../useGetAppPage'
import { useGetAppMenu } from '../../AppMenu/useGetAppMenu'
import clsx from 'clsx'

export function ContentPanel({ children }: { children: ReactNode }) {
  const {
    data: { items: menuItems },
  } = useGetAppMenu()
  const showSidebar = useMemo(() => menuItems.length > 1, [menuItems])
  const {
    data: { emphasizeHeader },
  } = useGetAppPage()
  const { isConfiguringLayout } = useAppPageState()
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const lastScrollTopRef = useRef(0)

  const handleScroll = useCallback(() => {
    const el = scrollContainerRef.current
    if (!el) return
    lastScrollTopRef.current = el.scrollTop
  }, [])

  useLayoutEffect(() => {
    if (!isConfiguringLayout) return
    const el = scrollContainerRef.current
    if (!el) return
    // Restore previous scroll position if a re-render/reset scrolled to top
    if (el.scrollTop !== lastScrollTopRef.current) {
      el.scrollTop = lastScrollTopRef.current
    }
  }, [children, isConfiguringLayout])
  const { headerHeight } = getPageHeights(emphasizeHeader ?? false)
  return (
    <div
      ref={scrollContainerRef}
      style={{ scrollPaddingTop: headerHeight + PADDING_GAP }}
      className={clsx(
        'relative h-full min-h-0 flex-1 snap-y snap-mandatory overflow-y-auto overflow-x-hidden scroll-smooth',
        { 'pl-4': !showSidebar }
      )}
      onScroll={handleScroll}
    >
      <div className="relative flex w-full flex-col bg-offwhite px-5 pl-1.5">{children}</div>
    </div>
  )
}
